import React, { useEffect, useState } from 'react';
import { Button, Col, Icon, message, Row, Spin } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'moment';
import useApi from '../../../../../Hooks/Api';
import { FaBackward, FaEdit, FaForward, FaPlus, FaTrashAlt, FaUniversity } from 'react-icons/fa';
import { MdWork } from 'react-icons/md';
import GradFormComponent from './GradFormComponent';
import { GiTiedScroll } from 'react-icons/all';

const GradComponent = (props) => {
   const [gradsData, setGradsData] = useState([]);
   const [gradSelected, setGradSelected] = useState(null);

   const api = useApi();
   const user = useSelector((state) => state).authReducer;
   const [initialLoading, setInitialLoading] = useState(true);
   const [loading, setLoading] = useState(false);
   const [isNewGrad, setIsNewGrad] = useState(false);

   const getGrads = async () => {
      setInitialLoading(true);
      api.get(
         `sine/user/${user.user_id}/academics`,
         (res) => {
            if (res.user_id !== null) {
               props.setHasProfile(true);
               if (res.academic?.length > 0) {
                  setGradsData(res.academic);
               } else {
                  setGradsData([]);
               }
               setInitialLoading(false);
            }
         },
         (e) => {
            console.log(e);
            setInitialLoading(false);
         }
      );

      window.scrollToElement('body');
   };

   const validAndFormatDate = (date) => {
      if (date) {
         if (moment(date, 'MM/YYYY').isValid()) {
            return moment(date, 'MM/YYYY').format('YYYY-MM');
         } else {
            console.log('nao eh valido');
            return false;
         }
      }
   };

   const onSaveGrad = async (action, values) => {
      setLoading(true);

      let aux = validAndFormatDate(values.end_date);
      if (aux !== false) values.end_date = aux;
      else {
         message.warning('Informe a data final corretamente (Dia/Mês)');
         setLoading(false);
         return 0;
      }

      aux = validAndFormatDate(values.start_date);
      if (aux !== false) values.start_date = aux;
      else {
         message.warning('Informe a data inicial corretamente (Dia/Mês)');
         setLoading(false);
         return 0;
      }

      message.loading(action === 'add' ? 'Adicionando...' : 'Editando...');
      const id = values.id || null;
      const method = action === 'add' ? 'post' : 'put';
      if ('id' in values) {
         delete values.id;
      }
      api[method](
         `sine/user/${user.user_id}/academic${action === 'add' ? '' : `/${id}`}`,
         values,
         (res) => {
            message.destroy();
            message.success('Sucesso!');
            action === 'add' && setIsNewGrad(false);
            action === 'edit' && setGradSelected(null);
            setLoading(false);
            getGrads();
         },
         (e) => {
            message.warning(e.message || 'Não foi possível salvar, tente novamente!');
            console.log(e);
            setLoading(false);
         }
      );
   };

   const handleDeleteGrad = async (id) => {
      if (!loading) {
         setLoading(true);
         message.loading('Removendo...');
         api.del(
            `sine/user/${user.user_id}/academic/${id}`,
            null,
            (res) => {
               setGradSelected(null);
               message.destroy();
               message.success('Sucesso!');
               getGrads();
               setLoading(false);
            },
            (e) => {
               console.log(e);
               message.warning(e.message || 'Não foi possível deletar, tente novamente!');
               setLoading(false);
            }
         );
      }
   };

   useEffect(() => {
      getGrads();
      window.scrollToElement('body');
   }, []);

   return (
      <div style={{ marginBottom: 200 }} className={'experienceForm aboutCss'}>
         <div
            style={{
               paddingBottom: 35,
               borderBottom: '1px solid gainsboro',
               textAlign: 'center',
               marginTop: 50,
            }}
         >
            <h1>
               <strong style={{ color: '#242424', fontSize: 25 }}> Suas graduações </strong>
            </h1>
            <span style={{ fontSize: 20, color: '#9E9E9E' }}>
               {' '}
               Adicione aqui caso tenha realizados algum curso de nível superior{' '}
            </span>
            <br />
            <span style={{ fontSize: 16, color: '#1890ff9e' }}>
               {' '}
               Clique no botão adicionar, e adicione todos os seus cursos de nível
               superior/graduações/faculdades{' '}
            </span>
            <br />
         </div>

         <Row
            className={'formTitle'}
            style={{
               display: 'flex',
               marginBottom: 35,
               justifyContent: 'flex-end',
            }}
         >
            <Button
               className={'ant-btn-green'}
               style={{
                  display: isNewGrad || gradSelected ? 'none' : 'flex',
                  fontSize: 16,
                  alignItems: 'center',
               }}
               onClick={() => setIsNewGrad(true)}
            >
               Adicionar <FaPlus style={{ color: 'white', fontSize: 17, marginLeft: 5 }} />
            </Button>
         </Row>

         {!isNewGrad && gradsData?.length === 0 && (
            <div className={'text-center'}>
               <h2>
                  Nenhuma graduação cadastrada
                  <br /> Adicione agora e aumente suas chances de conquistar um novo emprego!
               </h2>
            </div>
         )}

         <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {isNewGrad && <GradFormComponent action={'add'} loading={loading} onSubmit={onSaveGrad} onClose={() => setIsNewGrad(false)} />}

            {gradsData?.map((item, index) =>
               gradSelected?.id === item.id ?
                  <div>
                     <GradFormComponent
                        action={'edit'}
                        loading={loading}
                        data={gradSelected}
                        onSubmit={onSaveGrad}
                        onClose={() => setGradSelected(null)}
                        handleDelete={handleDeleteGrad}
                     />
                  </div>
               :  <Row
                     key={index}
                     style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        backgroundColor: 'white',
                     }}
                     className={'formRow'}
                  >
                     <Col xs={24} md={9} className={'listView'} style={{ alignItems: 'start' }}>
                        <FaUniversity />
                        <div style={{ maxWidth: 320 }}>
                           <span>{item?.university}</span>
                           <div>
                              <small>{item?.course}</small>
                           </div>
                        </div>
                     </Col>
                     <Col xs={24} md={10} className={'listView'}>
                        <GiTiedScroll size={22} />
                        <div>
                           <span>{item?.label}</span>
                           {item?.start_date && (
                              <div>
                                 <span>
                                    {' '}
                                    <small style={{ textTransform: 'capitalize' }}>
                                       {moment(item.start_date, 'YYYY-MM')
                                          .locale('pt-br')
                                          .format('MMM/YYYY')}
                                    </small>
                                 </span>
                                 {item?.end_date && (
                                    <span>
                                       {' '}
                                       -{' '}
                                       <small style={{ textTransform: 'capitalize' }}>
                                          {moment(item.end_date, 'YYYY-MM')
                                             .locale('pt-br')
                                             .format('MMM/YYYY')}
                                       </small>
                                    </span>
                                 )}
                              </div>
                           )}
                        </div>
                     </Col>
                     <Col
                        span={5}
                        style={{
                           justifyContent: 'flex-end',
                           padding: 0,
                           fontSize: 20,
                           display: 'flex',
                           alignItems: 'center',
                        }}
                     >
                        <div>
                           <FaEdit
                              className={'editButtonIcon'}
                              onClick={() => {
                                  isNewGrad && setIsNewGrad(false)
                                  setGradSelected(item)
                              }}
                           />
                        </div>
                        <div>
                           <FaTrashAlt
                              className={'removeButtonIcon'}
                              style={{ marginLeft: 20 }}
                              onClick={() => handleDeleteGrad(item.id)}
                           />
                        </div>
                     </Col>
                  </Row>
            )}
         </div>

         {initialLoading && gradsData.length === 0 ?
            <div className={'loadingResume'}>
               <Spin />
            </div>
         :  <div className={'buttonRow'}>
               <Button shape={'round'} onClick={() => props.handleChangeStep(1)} type={'default'}>
                  <FaBackward className={'exportedIconsLeft'} /> Voltar
               </Button>
               <Button
                  shape={'round'}
                  onClick={() => props.handleChangeStep(3)}
                  className={'ant-btn-sub-primary'}
               >
                  Próximo <FaForward className={'exportedIcons'} />
               </Button>
            </div>
         }
      </div>
   );
};
export default GradComponent;
